// extracted by mini-css-extract-plugin
export default {"proTips":"ProTips_proTips__TXqWI","title":"ProTips_title__x0kAc"};